import { ITrainingGroupValues } from './training-group-form-types'
import {
  ITrainingGroup,
  ITrainingGroupUpsert,
} from '../../../../interfaces'

export const trainingGroupToTrainingGroupValues = (
  trainingGroup: ITrainingGroup | undefined,
): ITrainingGroupValues | undefined => {
  if (!trainingGroup) {
    return undefined
  }

  return {
    name: trainingGroup?.name,
    description: trainingGroup?.description,
    sortOrder: String(trainingGroup?.sortOrder),
    isActive: trainingGroup?.isActive,
  }
}

export const trainingGroupValuesToTrainingGroupAddUpsert = (
  trainingGroupValues: ITrainingGroupValues,
): ITrainingGroupUpsert | undefined => {
  if (!trainingGroupValues) {
    return undefined
  }

  return {
    name: trainingGroupValues?.name,
    description: trainingGroupValues?.description,
    sortOrder: trainingGroupValues?.sortOrder || '0',
    isActive: trainingGroupValues?.isActive || false,
  }
}

export const trainingGroupValuesToTrainingGroupUpdateUpsert = (
  trainingGroupValues: ITrainingGroupValues,
  trainingGroup: ITrainingGroup,
): ITrainingGroupUpsert | undefined => {
  if (!trainingGroupValues || !trainingGroup?.id) {
    return undefined
  }

  return {
    id: trainingGroup.id,
    name: trainingGroupValues?.name,
    description: trainingGroupValues?.description,
    sortOrder: trainingGroupValues?.sortOrder,
    isActive: trainingGroupValues?.isActive,
  }
}